import Assignment, { AssignButton, SingleAssignmentWizard } from '../../../components/assignments';
import { Card, Col, Row, Space } from 'antd';
import AC from '../../../components/AccessControl';
import ContentLibraryHeader from '../../../components/navigation/ContentLibraryHeader';
import HighlightedContent from '../../../components/panels/HighlightedContent';
import LabeledContent from '../../../components/ui/LabeledContent';
import LanguageIndicator from '../../../components/ui/LanguageIndicator';
import { ModulePreview } from '../../../components/panels/ModulePreview';
import { ReportsAccessProvider } from '../../../lib/ReportsAccessContext';
import ShareLinkButton from '../../../components/ui/ShareLinkButton';
import { TargetIcon } from '../../../components/images/TargetIcon';
import Thumbnail from '../../../components/ui/Thumbnail';
import { bilingualText } from '../../../helpers/bilingualText';
import cmsFactory from '../../../components/cmsFactory';
import getResourceAssignmentData from '../../../helpers/getResourceAssignmentData';
import htmlStringToReactNodes from '../../../helpers/htmlStringToReactNodes';
const GamePreview = ({
  data
}) => {
  const assignment = getResourceAssignmentData(data);
  return <div className="preview-module-container" data-sentry-component="GamePreview" data-sentry-source-file="[slug].jsx">
      <ContentLibraryHeader showBackBtn={true} title={data.language.includes('en') && data.name} spanishTitle={data.language.includes('es') && data.spanishName} extra={<LanguageIndicator languages={data.language} />} data-sentry-element="ContentLibraryHeader" data-sentry-source-file="[slug].jsx" />
      <Space direction="vertical" style={{
      display: 'flex'
    }} data-sentry-element="Space" data-sentry-source-file="[slug].jsx">
        <Card data-sentry-element="Card" data-sentry-source-file="[slug].jsx">
          <Row data-sentry-element="Row" data-sentry-source-file="[slug].jsx">
            <Col md={16} sm={24} lg={12} data-sentry-element="Col" data-sentry-source-file="[slug].jsx">
              <div className="preview-column">
                <ModulePreview url={data.previewURL} data-sentry-element="ModulePreview" data-sentry-source-file="[slug].jsx" />{' '}
              </div>
            </Col>
            <Col md={8} sm={24} lg={12} data-sentry-element="Col" data-sentry-source-file="[slug].jsx">
              <div className="resources-information-container">
                <div style={{
                display: 'flex',
                gap: 8
              }}>
                  <ShareLinkButton data-sentry-element="ShareLinkButton" data-sentry-source-file="[slug].jsx" />
                  <ReportsAccessProvider data-sentry-element="ReportsAccessProvider" data-sentry-source-file="[slug].jsx">
                    <Assignment data-sentry-element="Assignment" data-sentry-source-file="[slug].jsx">
                      <SingleAssignmentWizard data-sentry-element="SingleAssignmentWizard" data-sentry-source-file="[slug].jsx" />
                      <AssignButton assignment={assignment} type="primary" data-sentry-element="AssignButton" data-sentry-source-file="[slug].jsx" />
                      <div style={{
                      flexGrow: 1
                    }} />
                      <AC.CheckAccess rule={AC.ruleFromHref({
                      pathname: 'toolkits/assignment-playlist'
                    })} data-sentry-element="unknown" data-sentry-source-file="[slug].jsx">
                        <AssignButton playlist assignment={assignment} type="primary" className="antd-btn-purple" data-sentry-element="AssignButton" data-sentry-source-file="[slug].jsx" />
                      </AC.CheckAccess>
                    </Assignment>
                  </ReportsAccessProvider>
                </div>
                {data.language.includes('en') && data.learningObjectiveHTML && <HighlightedContent title="Learning Objective" image={<TargetIcon style={{
                width: 40
              }} />} content={<div className="highlighted-description">
                        {htmlStringToReactNodes(data.learningObjectiveHTML)}
                      </div>} styles={{
                backgroundColor: '#f2f8fd',
                color: '#206986',
                border: 'solid 1px #20698620'
              }} />}
                {data.language.includes('es') && data.spanishLearningObjectiveHTML && <HighlightedContent title="Objetivo de aprendizaje" image={<TargetIcon style={{
                width: 40
              }} />} content={<div className="highlighted-description">
                        {htmlStringToReactNodes(data.spanishLearningObjectiveHTML)}
                      </div>} styles={{
                backgroundColor: '#fff8f8',
                color: '#AC0D0D',
                border: 'solid 1px #AC0D0D20'
              }} />}
              </div>
            </Col>
          </Row>
        </Card>
        {data.lessons.length > 0 && <Card>
            <h3 children={`${bilingualText(data.language, 'Related Lessons', 'Lecciones relacionadas')} (${data.lessons.length})`} />
            <div className="library-grid" style={{
          padding: 20,
          maxHeight: 260,
          overflowY: 'auto'
        }}>
              {data.lessons.map(lesson => <Thumbnail key={lesson.name} data={lesson} showText={false} link={{
            pathname: '/toolkits/lessons/[slug]',
            query: {
              slug: lesson.slug
            }
          }} />)}
            </div>
          </Card>}
      </Space>
    </div>;
};
export const getStaticProps = context => ({
  props: {
    dataURL: `/content/games/${context.params.slug}.json`
  }
});
export const getStaticPaths = () => ({
  fallback: false,
  paths: require('../../../public/content/games-paths.json')
});
export default cmsFactory(GamePreview);